import React from 'react';

import { bemBlock, Icon, Text, text } from '@neptune/shared/venus-ui';

import './TextWithIndicator.less';

const block = bemBlock('text-with-indicator');

type TextWithIndicatorProps = React.ComponentProps<typeof Text> & {
  showIndicator?: boolean;
  indicatorColor?: text.Color;
  indicatorSize?: React.ComponentProps<typeof Icon>['size'];
  indicatorTransform?: React.ComponentProps<typeof Icon>['transform'];
};

export function TextWithIndicator({
  showIndicator = false,
  indicatorColor = 'info',
  indicatorSize = '1x',
  size = 'sm',
  children,
  ...rest
}: TextWithIndicatorProps) {
  return (
    <Text className={block()} size={size} {...rest}>
      {children}
      {showIndicator && (
        <Icon
          className={block({ element: 'dot-indicator', modifiers: { color: indicatorColor } })}
          size={indicatorSize}
          glyph="dot"
        />
      )}
    </Text>
  );
}
